"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Button = _interopRequireDefault(require("../Button"));

var _PassengerRoomSelectionExpander = _interopRequireDefault(require("../PassengerRoomSelectionExpander"));

var _passengerRoomSelection = _interopRequireDefault(require("./passengerRoomSelection.proptypes"));

var _constant = require("./constant");

var _passengerRoomSelection2 = _interopRequireDefault(require("./passengerRoomSelection.util"));

var _constant2 = require("../constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var PassengerRoomSelectionWrapper = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelection__PassengerRoomSelectionWrapper",
  componentId: "sc-kt8w9u-0"
})(["display:flex;flex-direction:column;", " background-color:", ";"], function (_ref) {
  var device = _ref.device;
  return device === _constant2.DEVICE_TYPE.MOBILE && "max-height: calc(100vh - 150px);\n     width: 100vw;";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.primary;
});

var RoomContainer = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelection__RoomContainer",
  componentId: "sc-kt8w9u-1"
})(["flex:1;", ";}"], function (_ref3) {
  var device = _ref3.device;
  return device === _constant2.DEVICE_TYPE.MOBILE && "\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n  width: 0px;  /* Remove scrollbar space */\n  background: transparent;  /* make scrollbar invisible */";
});

var FooterContainer = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelection__FooterContainer",
  componentId: "sc-kt8w9u-2"
})(["justify-content:flex-end;", ""], function (_ref4) {
  var device = _ref4.device;
  return device === _constant2.DEVICE_TYPE.MOBILE && "position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    ";
});

var ExpanderContainer = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelection__ExpanderContainer",
  componentId: "sc-kt8w9u-3"
})(["padding:", ";", ""], function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.small);
}, function (_ref6) {
  var device = _ref6.device;
  return device === _constant2.DEVICE_TYPE.MOBILE ? "padding-top: 0;" : "padding-bottom: 0;";
});

var PassengerRoomSelectionFooter = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelection__PassengerRoomSelectionFooter",
  componentId: "sc-kt8w9u-4"
})(["display:flex;justify-content:space-between;align-items:center;box-shadow:0px 0px 6px rgba(0,0,0,0.2);padding:", ";margin-top:", ";background-color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.small;
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.small);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.backgroundColor.default;
});

var AddRoomButton = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelection__AddRoomButton",
  componentId: "sc-kt8w9u-5"
})(["display:inline-block;cursor:pointer;", ""], function (_ref10) {
  var canAddRoom = _ref10.canAddRoom;
  return !canAddRoom && "pointer-events: all;\n    cursor: not-allowed !important;";
});

var PassengerRoomSelection = function PassengerRoomSelection(props) {
  var data = props.data,
      onRoomSubmit = props.onRoomSubmit,
      maxPassengerLimit = props.maxPassengerLimit,
      device = props.device,
      theme = props.theme,
      accessible = props.accessible,
      alwayEnableAddRoom = props.alwayEnableAddRoom,
      isShowChildAgeInput = props.isShowChildAgeInput,
      isShowInfantSelect = props.isShowInfantSelect,
      enablePaxAgeUpdate = props.enablePaxAgeUpdate;

  var _ref11 = data || {},
      roomOccupancy = _ref11.roomOccupancy,
      defaultRoomOccupancy = _ref11.defaultRoomOccupancy,
      minRooms = _ref11.minRooms,
      maxRooms = _ref11.maxRooms,
      maxPassengers = _ref11.maxPassengers,
      labels = _ref11.labels,
      maxPassengersPerRoom = _ref11.maxPassengersPerRoom,
      roomChildAge = _ref11.roomChildAge,
      ageList = _ref11.ageList;

  var _useState = (0, _react.useState)(_passengerRoomSelection2.default.updateRoomOccupancy(roomOccupancy, minRooms, defaultRoomOccupancy)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      paxCount = _useState2[0],
      setPaxCount = _useState2[1];

  var _useState3 = (0, _react.useState)(roomChildAge !== null && roomChildAge !== void 0 ? roomChildAge : null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      childAge = _useState4[0],
      setChildAge = _useState4[1];

  var _useState5 = (0, _react.useState)(paxCount.length - 1),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      expandId = _useState6[0],
      setExpandId = _useState6[1];

  var _useState7 = (0, _react.useState)(_passengerRoomSelection2.default.getTotalGuests(paxCount)),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      totalGuests = _useState8[0],
      setTotalGuests = _useState8[1];

  (0, _react.useEffect)(function () {
    setExpandId(paxCount.length - 1);
  }, [paxCount.length]);
  (0, _react.useEffect)(function () {
    setTotalGuests(_passengerRoomSelection2.default.getTotalGuests(paxCount));
  }, [paxCount]);

  var handleOnExpanderClick = function handleOnExpanderClick(index) {
    setExpandId(index);
  };

  var changePaxCount = function changePaxCount(index) {
    return function (updatedPaxCount) {
      var roomCount = paxCount[index];
      var updatedRoomOccupancy = [].concat((0, _toConsumableArray2.default)(paxCount.slice(0, index)), [_objectSpread(_objectSpread({}, roomCount), updatedPaxCount)], (0, _toConsumableArray2.default)(paxCount.slice(index + 1)));
      setPaxCount(updatedRoomOccupancy);
    };
  };

  var changeChildAge = function changeChildAge(index) {
    return function (pax) {
      if (isShowChildAgeInput) {
        var childRoom = (0, _toConsumableArray2.default)(childAge);
        childRoom[index] = pax;
        setChildAge(childRoom);
      }
    };
  };

  var removeRoom = function removeRoom(e) {
    e.stopPropagation();
    paxCount.pop();
    setPaxCount((0, _toConsumableArray2.default)(paxCount));

    if (isShowChildAgeInput) {
      childAge.pop();
      setChildAge((0, _toConsumableArray2.default)(childAge));
    }
  };

  var addRoom = function addRoom(e, canAddRoom) {
    e.stopPropagation();

    if (canAddRoom) {
      setPaxCount([].concat((0, _toConsumableArray2.default)(paxCount), [defaultRoomOccupancy]));

      if (isShowChildAgeInput) {
        setChildAge([].concat((0, _toConsumableArray2.default)(childAge), [new Array(defaultRoomOccupancy.child).fill(ageList[0])]));
      }
    }
  };

  var handleRoomSubmit = function handleRoomSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (onRoomSubmit) onRoomSubmit(paxCount, totalGuests, paxCount.length, childAge);
  };

  var shouldDisableSelection = function shouldDisableSelection(room) {
    var totalGuestByRoom = _passengerRoomSelection2.default.getTotalGuestsByRoom(room, paxCount);

    if (maxPassengerLimit) return maxPassengerLimit && totalGuests === +maxPassengers;

    if (maxPassengersPerRoom) {
      return maxPassengersPerRoom && totalGuestByRoom === maxPassengersPerRoom;
    }

    return false;
  };

  var shouldDisableAddRoom = function shouldDisableAddRoom() {
    return alwayEnableAddRoom ? !alwayEnableAddRoom : maxPassengerLimit && totalGuests === +maxPassengers;
  };

  var renderRooms = function renderRooms() {
    var PassengerRoomSelectionExpanderComponents = [];
    var showRemove = !minRooms || paxCount.length > minRooms;

    var _loop = function _loop(i) {
      PassengerRoomSelectionExpanderComponents.push( /*#__PURE__*/_react.default.createElement(ExpanderContainer, {
        device: device
      }, /*#__PURE__*/_react.default.createElement(_PassengerRoomSelectionExpander.default, {
        key: i,
        theme: theme,
        expanderTitle: labels.roomTitle.replace('{0}', i + 1),
        expand: i === expandId,
        device: device,
        handleClick: function handleClick() {
          return handleOnExpanderClick(i);
        },
        onChangeData: changePaxCount(i),
        changeChildAge: changeChildAge(i),
        showRemove: showRemove && i === paxCount.length - 1,
        onRemove: function onRemove(e) {
          return removeRoom(e);
        },
        data: _objectSpread(_objectSpread({}, data), {}, {
          passengerCount: paxCount[i],
          childList: isShowChildAgeInput && childAge[i],
          stepperConfig: {
            disableIncrement: shouldDisableSelection(i)
          }
        }),
        isShowChildAgeInput: isShowChildAgeInput,
        isShowInfantSelect: isShowInfantSelect,
        enablePaxAgeUpdate: enablePaxAgeUpdate
      })));
    };

    for (var i = 0; i <= paxCount.length - 1; i += 1) {
      _loop(i);
    }

    return PassengerRoomSelectionExpanderComponents;
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var moveButtonThemeStyle = {
    true: {
      backgroundColor: 'primary',
      border: 'secondary',
      color: 'secondary',
      hoverBackgroundColor: 'primaryDark',
      hoverColor: 'secondary'
    },
    false: {
      backgroundColor: _constant.DEFAULT_STYLE.ROOM_SUBMIT_BUTTON.BACKGROUND_COLOR,
      color: _constant.DEFAULT_STYLE.ROOM_SUBMIT_BUTTON.COLOR
    }
  };
  var activeColor = {
    true: {
      true: 'tertiaryRed',
      false: _constant.DEFAULT_STYLE.ADD_BUTTON.DISABLED_COLOR
    },
    false: {
      true: _constant.DEFAULT_STYLE.ADD_BUTTON.ACTIVE_COLOR,
      false: _constant.DEFAULT_STYLE.ADD_BUTTON.DISABLED_COLOR
    }
  };
  var isMoveTheme = theme === 'AIRASIA_MOVE' || (themeContext === null || themeContext === void 0 ? void 0 : themeContext.type) === 'AIRASIA_MOVE';

  var getMain = function getMain() {
    var canAddRoom = shouldDisableAddRoom() ? !shouldDisableAddRoom() : paxCount.length < maxRooms;
    return /*#__PURE__*/_react.default.createElement(PassengerRoomSelectionWrapper, {
      id: "passenger-room-selection-wrapper",
      device: device,
      tabIndex: tabIndex
    }, /*#__PURE__*/_react.default.createElement(RoomContainer, {
      id: "room-container",
      device: device
    }, renderRooms()), /*#__PURE__*/_react.default.createElement(FooterContainer, {
      id: "footer-container",
      device: device
    }, /*#__PURE__*/_react.default.createElement(PassengerRoomSelectionFooter, null, /*#__PURE__*/_react.default.createElement(AddRoomButton, {
      "data-test": "add-room-button",
      onClick: function onClick(e) {
        return addRoom(e, canAddRoom);
      },
      canAddRoom: canAddRoom
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "inlineFlex",
      theme: theme,
      type: _constant.DEFAULT_STYLE.ADD_BUTTON.TYPE,
      color: activeColor[isMoveTheme][canAddRoom]
    }, "+ ".concat(labels.roomAddButton))), /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, moveButtonThemeStyle[isMoveTheme], {
      boxShadow: true,
      buttonType: _constant.DEFAULT_STYLE.ROOM_SUBMIT_BUTTON.BUTTON_TYPE,
      customProperties: {
        id: 'room-selection-done-button'
      },
      size: _constant.DEFAULT_STYLE.ROOM_SUBMIT_BUTTON.SIZE,
      theme: theme,
      type: _constant.DEFAULT_STYLE.ROOM_SUBMIT_BUTTON.TYPE,
      handleClick: function handleClick(e) {
        return handleRoomSubmit(e);
      },
      "data-test": "room-submit-button",
      paddingLeft: "32px",
      paddingRight: "32px"
    }), labels.roomSubmitButton))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PassengerRoomSelection.propTypes = _passengerRoomSelection.default.PropTypes;
PassengerRoomSelection.defaultProps = _passengerRoomSelection.default.DefaultProps;
var _default = PassengerRoomSelection;
exports.default = _default;